(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tax-office', {
            parent: 'entity',
            url: '/tax-office?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.taxOffice.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tax-office/tax-offices.html',
                    controller: 'TaxOfficeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('taxOffice');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tax-office-detail', {
            parent: 'entity',
            url: '/tax-office/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.taxOffice.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tax-office/tax-office-detail.html',
                    controller: 'TaxOfficeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('taxOffice');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TaxOffice', function($stateParams, TaxOffice) {
                    return TaxOffice.get({id : $stateParams.id});
                }]
            }
        })
        .state('tax-office.new', {
            parent: 'tax-office',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tax-office/tax-office-dialog.html',
                    controller: 'TaxOfficeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tax-office', null, { reload: true });
                }, function() {
                    $state.go('tax-office');
                });
            }]
        })
        .state('tax-office.edit', {
            parent: 'tax-office',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tax-office/tax-office-dialog.html',
                    controller: 'TaxOfficeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TaxOffice', function(TaxOffice) {
                            return TaxOffice.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('tax-office', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tax-office.delete', {
            parent: 'tax-office',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tax-office/tax-office-delete-dialog.html',
                    controller: 'TaxOfficeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TaxOffice', function(TaxOffice) {
                            return TaxOffice.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('tax-office', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
